import React from 'react'

/** Copy belongs to the localized producer; this primitive only presents it. */
export function SlideNotice({ children, style, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div data-testid="slide-notice" role="note" {...props} style={{ fontSize: 13, lineHeight: 1.4, color: 'var(--slide-text-muted)', marginTop: 12, ...style }}>{children}</div>
}
